import { render, staticRenderFns } from "./WBggTable.vue?vue&type=template&id=217ba998&scoped=true"
import script from "./WBggTable.vue?vue&type=script&lang=js"
export * from "./WBggTable.vue?vue&type=script&lang=js"
import style0 from "./WBggTable.vue?vue&type=style&index=0&id=217ba998&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "217ba998",
  null
  
)

export default component.exports